export interface IMachineTypeRules {
  requiredField: 'email' | 'phone';
  autoAddField: 'email' | 'phone';
  emailRequired: boolean;
  phoneRequired: boolean;
  emailRemovable: boolean;
  phoneRemovable: boolean;
}

export const getMachineTypeRules = (
  machineType: string | number
): IMachineTypeRules => {
  const normalizedMachineType = Number(machineType);

  if (normalizedMachineType === 3 || normalizedMachineType === 5) {
    return {
      requiredField: 'phone',
      autoAddField: 'phone',
      emailRequired: false,
      phoneRequired: true,
      emailRemovable: true,
      phoneRemovable: false
    };
  }

  return {
    requiredField: 'email',
    autoAddField: 'email',
    emailRequired: true,
    phoneRequired: false,
    emailRemovable: false,
    phoneRemovable: true
  };
};

export function isFieldRequired(
  fieldType: string,
  rulesOrMachineType: IMachineTypeRules | string | number
): boolean {
  const rules =
    typeof rulesOrMachineType === 'object'
      ? rulesOrMachineType
      : getMachineTypeRules(rulesOrMachineType);

  if (fieldType === 'email') {
    return rules.emailRequired;
  }

  if (fieldType === 'tel' || fieldType === 'phone') {
    return rules.phoneRequired;
  }

  return false;
}

export function isFieldRemovable(
  fieldType: string,
  rulesOrMachineType: IMachineTypeRules | string | number
): boolean {
  const rules =
    typeof rulesOrMachineType === 'object'
      ? rulesOrMachineType
      : getMachineTypeRules(rulesOrMachineType);

  if (fieldType === 'email') {
    return rules.emailRemovable;
  }

  if (fieldType === 'tel' || fieldType === 'phone') {
    return rules.phoneRemovable;
  }

  return true;
}
